module.exports = __webpack_public_path__ + "static/media/alcatel-lucent-logo-charcoal.b024aadb.svg";